import React from 'react';
import * as Styled from './styles';
import TableSkeleton from '../../../UIelements/Skeleton/TableSkeleton';

const EquipmentTableSkeleton: React.FC = () => (
  <Styled.Card>
    <Styled.SectionTitle />
    <TableSkeleton rows={4} />
  </Styled.Card>
);

export default EquipmentTableSkeleton;
